import { Joi, objectSchemaOf } from '../helpers';

export interface IJobsAvailableResult {
  conversationId?: string;
  available: boolean;
  interventionRequired: boolean;
}

export const jobsAvailableResultSchema = objectSchemaOf<IJobsAvailableResult>({
  conversationId: Joi.string().optional(),
  available: Joi.boolean().required(),
  interventionRequired: Joi.boolean().required(),
});
